const localSelectedAccountantOutletData = JSON.parse(window.localStorage.getItem('selectedAccountantOutletDatas'))
const selectedAccountantDayData = JSON.parse(window.localStorage.getItem('selectedAccountantDayData'))

const state = {
  selectedAccountantOutletData: localSelectedAccountantOutletData,
  selectedAccountantDayData: selectedAccountantDayData
}
const mutations = {
  addAccountantSelectedOutletData (state, data) {
    state.selectedAccountantOutletData = data
    this.commit('saveAccountantSelectedOutletData')
  },
  saveAccountantSelectedOutletData (state) {
    window.localStorage.setItem('selectedAccountantOutletData', JSON.stringify(state.selectedAccountantOutletData))
  },
  addAccountantSettlementDayData (state, data) {
    state.selectedAccountantDayData = data
    this.commit('saveAccountantSelectedDayData')
  },
  saveAccountantSelectedDayData (state) {
    window.localStorage.setItem('selectedAccountantDayData', JSON.stringify(state.selectedAccountantDayData))
  }
}
export default {
  state,
  mutations
  // getters
}
